import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { HelpService } from '../../../services/help.service';
import { IdleService } from '../../../services/idle.service';
import { ExperienceManager } from '../../../managers/experience.manager';
import { getCookie } from '../../../utilities/cookies';
import { NotificationManager } from '../../../managers/notification.manager';
import { BaseComponent } from '../../base.component';

@Component({
    selector: 'lex-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent extends BaseComponent implements OnInit, OnDestroy {
	public state: 'ready' | 'email-sent' = 'ready';
	public contactForm = this.formBuilder.group({
		username: [null, Validators.required],
	});

	constructor(
		private readonly router: Router,
		private readonly formBuilder: UntypedFormBuilder,
		private readonly authenticationService: AuthenticationService,
		private readonly helpService: HelpService,
		private readonly idleService: IdleService,
		private readonly experienceManager: ExperienceManager,
		private readonly notificationManager: NotificationManager
	) {
		super();

		this.experienceManager.updateState({
			showTopBar: false
		});
	}

	ngOnDestroy() {
		this.experienceManager.updateState({
			showTopBar: true
		});
	}

	ngOnInit() {
		const userName = getCookie('UserName');
		if (userName != undefined) {
			this.contactForm = this.formBuilder.group({
				username: [userName, Validators.required],
			});
		}
		this.helpService.updateHelpLink('logging-in');
	}

	public requestForgotPassword() {
		if (!this.contactForm.valid) return;

		this.authenticationService
			.forgotPassword(this.contactForm.value.username)
			.subscribe(() => {
				this.state = 'email-sent';
			}, () => {
				this.notificationManager.displaySnackBarMessage({ message: 'An error has occurred. Please contact Professional Services for support.', type: 'error', ttl: 10000 });
			});
	}
}
